// extracted by mini-css-extract-plugin
module.exports = {"editor":"SimpleMentionEditor_editor__2YHzN","SimpleMentionEditor_editor__2YHzN":"SimpleMentionEditor_SimpleMentionEditor_editor__2YHzN__3l0po"};